import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reporteCostoInventario';
import ReporteLoteInventario from './ReporteLoteInventario';

const mstp = state => {
    return {
        ...state.reporteCostoInventario,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteLoteInventario)
